import {Message} from 'element-ui';

export function showInfo(message) {
  Message({
    message: message
  });
}

export function showSuccess(message) {
  Message({
    message: message,
    type: 'success'
  });
}

export function showWarn(message) {
  Message({
    message: message,
    type: 'warning'
  });
}

export function showError(message) {
  Message.error(message);
}



// WEBPACK FOOTER //
// ./src/utils/msg.js